<template>
  <preload-content :loading="isLoading()" :min-height="isLoading() ? '300px' : 'auto'">
    <template v-if="!isLoading()">
      <template v-if="specializations.length">
        <div class="settings__bottom">
          <div class="settings__bottom-prices">
            <h3>Услуги и цены</h3>
            <template v-if="!isMobile">
              <button v-if="isHidden" @click="isHidden = !isHidden">Редактировать</button>
              <div v-if="!isHidden" @click="isHidden = !isHidden" class="close"><img src="../../../../assets/images/icons/close.svg" alt=""></div>
            </template>
            <button v-else @click="editPricesMobile">Ред.</button>
          </div>
        </div>
        <div class="settings__services">
        <span v-for="specialization in specializations" :key="specialization.id">
          <h3>{{ specialization.name }}</h3>
          <price-list
              :specialization="specialization.id"
              :list="prices[specialization.id]"
              :errors="errors[specialization.id]"
              :hide="isHidden"
              :id="`${specialization.id}`"
              :per-hour="true"
              @addItem="addItem"
              @delete="del"
          />
        </span>
        </div>
      </template>
    </template>
  </preload-content>
</template>

<script>
import PreloadContent from '../../../../components/ui/preload-content';
import PriceList from './PriceList';
import { mapMutations } from 'vuex'

export default {
  name: "Prices",
  components: {PriceList, PreloadContent},
  data () {
    return {
      prices: null,
      specializations: null,
      isHidden: true,
      errors: {}
    }
  },
  computed: {
    isMobile () {
      return document.documentElement.clientWidth < 991
    }
  },
  mounted() {
    this.reload();
    this.$eventHub.$on('price.reload', () => this.reload());
  },
  methods: {
    ...mapMutations(['openModal', 'setModalData']),
    reload() {
      this.prices = null;
      this.specializations = null;
      this.errors = {};
      this.loadPrices();
      this.loadSpecializations();
    },
    isLoading() {
      return !this.prices || !this.specializations;
    },
    addItem(item, specialization) {
      let form = Object.assign({}, item);
      form.specialization_id = specialization;
      console.log('form', form)
      this.$api.master.price.create(form).then(({data}) => {
        this.appendPrice(data);
        this.$eventHub.$emit('price.created');
        this.errors[specialization] = {};
      }).catch(({response}) => this.errors[specialization] = response.data.errors);
    },
    del(item, index) {
      this.$api.master.price.destroy(item.id).then(() => this.prices[item.specialization_id].splice(index, 1));
    },
    appendPrice(val) {
      if (!this.prices[val.specialization_id]) this.$set(this.prices, val.specialization_id, []);
      this.prices[val.specialization_id].push(val);
    },
    loadSpecializations() {
      return this.$api.master.specialization.list().then(({data}) => {
        this.specializations = data;
        this.specializations.map(val => this.$set(this.errors, val.id, {}));
      });
    },
    loadPrices() {
      return this.$api.master.price.cabinetList().then(({data}) => {
        this.prices = {};
        data.map((val) => this.appendPrice(val));
      });
    },
    editPricesMobile() {
      this.openModal('master_cabinet_settings_edit_modal')
      this.setModalData({prices: this.prices, specializations: this.specializations})
    }
  },
  beforeDestroy() {
    this.$eventHub.$off('price.reload');
  },
}
</script>

<style scoped lang="scss">
h3 {
  padding-bottom: 0;
}

.settings {
  padding: 30px 30px 0 30px;

  &__top {
    padding-bottom: 30px;

    h3 {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #383838;
      padding-bottom: 20px;
    }
  }

  &__bottom {
    padding: 30px -15px 0 0;
    border-top: 1px solid #E5E5E5;
    display: flex;
    h3 {
      margin-bottom: 0;
    }

    &-prices {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 25px;

      .close {
        height: 50px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      h3 {
        padding-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      button {
        margin-top: 0;
        width: auto;
        font-weight: 600;
        font-size: 16px;
        line-height: 1.4;
        color: #B9765B;
        background-color: transparent;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 0;

        &:before {
          content: '';
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-image: url("../../../../assets/images/icons/edit.svg");
          background-position: center center;
          background-size: contain;
        }
      }
    }
  }

  &__services {
    padding-bottom: 10px;

    h3 {
      padding-top: 15px;
    }

    button {
      visibility: visible;
      height: 20px;
      margin-top: 0;
      width: auto;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.4;
      color: #B9765B;
      background-color: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 10px 0 25px 0;

      &:before {
        content: '';
        width: 20px;
        height: 20px;
        margin-right: 5px;
        background-image: url("../../../../assets/images/icons/edit.svg");
        background-position: center center;
        background-size: contain;
      }
    }
  }
}

.select {
  height: 37.5px;
  width: 100%;
  max-width: unset;
  margin-bottom: 20px;
}

button {
  width: 100%;
  height: 50px;
  border: none;
  background: #DBBFA7;
  border-radius: 5px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #383838;
  margin-top: 15px;
}

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;

  .camera {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;

    &:hover .camera-visible {
      visibility: visible;
    }

    .camera-visible {
      visibility: hidden;
      position: absolute;
      background: rgba(56, 56, 56, 0.70);
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;

      img {
        width: 37.95px;
        height: 30.8px;
        border-radius: unset;
      }
    }
  }

  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
  }
}

h3 {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
  padding-bottom: 0;
}

.params {
  padding-left: 10px;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #808080;
}

.settings-input {
  position: relative;
  width: 100%;

  input {
    width: 100%;
    height: 37.5px;
    background: #FFFFFF;
    border: 1px solid #DBBFA7;
    border-radius: 5px;
    padding-left: 20px;
    color: #383838;
    font-size: 16px;

    &::placeholder {
      font-size: 16px;
      line-height: 24px;
      color: #808080;
    }
  }

  button {
    margin-top: 10px;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    border: none;
    background-image: url('../../../../assets/images/icons/eye-off.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
  }

  button.text {
    background-image: url('../../../../assets/images/icons/eye.svg');
  }
}
</style>
